import commonService from '@/services/ComunServices'
import accountServices from '@/services/AccountsServices'
import AppConfig from '@/config/AppConfig'

import axios from 'axios'
const state = {
    loadingUsers: false,
    users: []
};

const getters = {
    loadingUsers: state => {
        return state.loadingUsers;
    },
    users: state => {
        return state.users;
    }
};

const actions = {

    getUsers(context) {
        context.commit("showLoadingUsersIndicator")
        return accountServices.getAccountsIAM()
            .then(res => {

                context.commit("getUsers", res.data.data.profiles)
            }).catch(function (error) {
                console.log(error.response);
            });
    },
    searchExternalAgent(context, userID) {
        return commonService.getExternalAgents(userID)
            .then(res => {
                return res;
            })

    },
    registerUser(context, newUser) {
        newUser.email = newUser.email.toLowerCase()
        newUser.profile.email = newUser.email.toLowerCase()
        return accountServices.createAccountIAM(newUser)
            .then(res => {
                return res;
            })
    }
};

const mutations = {
    showLoadingUsersIndicator(state) {
        state.loadingUsers = true;
    },
    hideLoadingUsersIndicator(state) {
        state.loadingUsers = false;
    },
    getUsers(state, data) {
        var userAux = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].profile) {
                /* if(!data[i].profile.user_id||data[i].profile.business_name==''||data[i].profile.business_name==null)
                {
                    data[i].profile.user_id='0000'
                } */
                if (!data[i].profile.business_name) {
                    if (typeof data[i].profile.second_surname !== 'undefined') {
                        data[i].profile['fullName'] = data[i].profile.first_name + " " + data[i].profile.first_surname + " " + data[i].profile.second_surname;

                    } else {
                        data[i].profile['fullName'] = data[i].profile.first_name + " " + data[i].profile.first_surname;

                    }
                } else {
                    data[i].profile['fullName'] = data[i].profile.business_name;
                }
                userAux.push(data[i]);
            }

        }
        state.loadingUsers = false;
        state.users = userAux;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};